// src/pages/RepayLoan.js
import React, { useState, memo } from 'react';
import './repay-loan.css';

import idfcLogo from '../assets/images/idfc_logo_for_ac.jpg';
import idfcQr from '../assets/images/idfcqrcode.png';

const banks = [
  {
    name: 'IDFC FIRST Bank',
    logo: idfcLogo,
    qr: idfcQr,
    upi: 'marathonpvtltd@idfcbank',
    accountName: 'Marathon Finlease Private Limited',
    accountNumber: '62612199511',
    ifsc: 'IDFB0020151',
    branch: 'G-61 & G-62 Noida Sector-18',
    accountType: 'Current Account',
  },
];

const BankCard = memo(({ bank }) => (
  <div className="row align-items-center repay-card mb-5 p-4 shadow rounded-4 bg-white">
    <div className="col-md-7 mb-4 mb-md-0">
      <div className="text-center mb-3">
        <img src={bank.logo} alt={`${bank.name} logo`} className="bank-logo mb-2" style={{ height: '60px' }} />
      </div>
      <h4 className="fw-bold text-primary">Bank Details</h4>
      <div className="bank-details ps-md-3">
        <p><strong>Bank Name:</strong> {bank.name}</p>
        <p><strong>Company Name:</strong> {bank.accountName}</p>
        <p><strong>Account No.:</strong> {bank.accountNumber}</p>
        <p><strong>IFSC Code:</strong> {bank.ifsc}</p>
        <p><strong>Branch Name:</strong> {bank.branch}</p>
        <p><strong>Account Type:</strong> {bank.accountType}</p>
      </div>
    </div>
    <div className="col-md-5 text-center">
      <h4 className="fw-bold text-primary">QR Code / UPI</h4>
      <p className="fw-semibold">SCAN & PAY</p>
      {bank.qr && <img src={bank.qr} alt={`${bank.name} QR Code`} className="qr-image mb-3" style={{ width: '260px', borderRadius: '10px' }} />}
      {bank.upi && <p className="mb-0"><strong>UPI ID:</strong> {bank.upi}</p>}
    </div>
  </div>
));

const RepayLoan = () => {
  const [mobile, setMobile] = useState('');
  const [customer, setCustomer] = useState(null);
  const [error, setError] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`https://fundswalla.in/Api/TaskApi/oldUserHistory?pancard=${mobile}`);
      const data = await response.json();

      if (data?.listTask?.length > 0) {
        const user = data.listTask[0];
        setCustomer({
          name: user.first_name,
          mobile: user.mobile,
          lead_id: user.lead_id,
          loan_no: user.loan_no,
          pan: user.pancard,
          repayAmount: user.total_repayable,
          tillDateRepayAmount: user.repayment_amount,
          repayDate: user.repayment_date,
          status: user.status,
          email: user.email || 'user@example.com',
          id: user.id || 'CUS',
        });
        setError('');
      } else {
        setCustomer(null);
        setError('Customer not found');
      }
    } catch (err) {
      console.error(err);
      setCustomer(null);
      setError('Something went wrong. Please try again later.');
    }
  };

  return (
    <div className="repay-loan-page">

      <section className="hero-section text-white text-center py-3">
        <div className="container">
          <h1 className="fw-bold">Repay Your Loan</h1>
          <p className="lead mt-3 repay-subtitle">
            Choose your preferred bank and make hassle-free repayments.
          </p>
        </div>
      </section>

      <section className="container mt-5">
        <form onSubmit={handleSearch} className="d-flex flex-column flex-md-row align-items-md-center gap-3 mb-4">
          <input
            type="text"
            className="form-control"
            placeholder="Enter Mobile Number / PAN Number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            required
          />
          <button type="submit" className="btn custom-submit-btn">Submit</button>
        </form>

        {error && <div className="alert alert-danger">{error}</div>}

        {customer && (
          <div className="table-responsive mb-5">
            <table className="table table-bordered text-center align-middle">
              <thead className="table-light">
                <tr>
                  <th>Customer Name</th>
                  <th>Mobile Number</th>
                  <th>PAN No</th>
                  <th>Repay Amount</th>
                  <th>Till Date Repay Amount</th>
                  <th>Status</th>
                  <th>Repay Date</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{customer.name}</td>
                  <td>{customer.mobile}</td>
                  <td>{customer.pan}</td>
                  <td>₹{customer.tillDateRepayAmount}</td>
                  <td>₹{customer.repayAmount}</td>
                  <td>{customer.status}</td>
                  <td>{customer.repayDate}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </section>

      <section className="mt-5 bg-light">
        <div className="container">
          {banks.map((bank, index) => (
            <BankCard key={index} bank={bank} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default RepayLoan;
